import { useEffect, useRef } from 'react';

import { ResponseStatus } from '@revenuemarket/http';
import { Toast } from '@revenuemarket/ui';
import { debounce } from 'lodash-es';
import { useRouter } from 'next/router';

import { useHandleLoginSuccess } from '~components/Auth/Signin/callbacks';
import { useDemoTrialToken } from '~hooks/queries/auth/query';
import useSuperUserHook from '~hooks/useSuperUserHook';
import { NextPageWithLayout } from '~pages/_app';

const DemoTrialPage: NextPageWithLayout = () => {
  const router = useRouter();
  const hasCalledRef = useRef(false);

  const session = useSuperUserHook();
  const { mutateAsync: createDemoTrialToken } = useDemoTrialToken();
  const { handleLoginSuccess, contextHolder } = useHandleLoginSuccess();

  useEffect(() => {
    const handleDemoTrial = async () => {
      if (!hasCalledRef.current) {
        hasCalledRef.current = true;

        // 이미 로그인된 상태라면 바로 홈으로 리다이렉트
        if (session?.status === 'authenticated') {
          router.push('/clobe/home');
          return;
        }

        try {
          const response = await createDemoTrialToken();

          if (response?.Status === ResponseStatus.SUCCESS && response?.Data?.data?.token) {
            // 데모 토큰 발급 성공 -> handleLoginSuccess로 로그인 처리
            handleLoginSuccess({
              accessToken: response.Data.data.token,
              callbackUrl: '/clobe/home',
            });
          } else {
            Toast.error('데모 체험을 시작할 수 없습니다.');
            router.push('/auth/signup');
          }
        } catch (error) {
          Toast.error('데모 체험을 시작할 수 없습니다.');
          router.push('/auth/signup');
        }
      }
    };

    // debounce를 사용하여 중복 호출 방지
    debounce(handleDemoTrial, 300)();
  }, [session, createDemoTrialToken, handleLoginSuccess, router]);

  return <div>{contextHolder}</div>;
};

DemoTrialPage.getLayout = (page: React.ReactNode) => <>{page}</>;

export default DemoTrialPage;
